module.exports = __webpack_public_path__ + "img/1440.1b806dc1.jpg";